export const heroData = {
  preTag: '每日更新 · 高清流畅 · 告别片荒',
  h1: '91免费在线视频 — 精品影视在线播放平台',
  slogan: '发现你的下一部心头好，必看影视一网打尽',
  description: '精选全球高分电影与热门电视剧，每日更新精品推荐，为你打造专属观影清单。无论你偏爱悬疑烧脑、温情治愈还是史诗巨制，这里都有值得一看的优质内容。全站高清画质，流畅播放体验，让每一帧都精彩呈现。告别剧荒，从这一刻开始。',
  stats: [
    { label: '每日更新', value: '精品推荐' },
    { label: '全站高清', value: '流畅播放' },
    { label: '海量资源', value: '持续扩充' },
  ],
  primaryCta: { text: '立即探索精选', href: '#cards' },
  secondaryCta: { text: '查看热门排行', href: '#ranking' },
};

export const featuresData = [
  {
    id: 'f1',
    icon: 'ri-movie-2-line',
    title: '高分电影精选',
    desc: '严选豆瓣、IMDb 高分佳作，拒绝烂片，每部都值得花时间品味。',
  },
  {
    id: 'f2',
    icon: 'ri-tv-2-line',
    title: '热播剧集追踪',
    desc: '紧跟各大平台热播剧进度，第一时间推荐当季必追好剧。',
  },
  {
    id: 'f3',
    icon: 'ri-4k-line',
    title: '高清流畅体验',
    desc: '全站支持高清画质播放，自适应带宽，观影过程不卡顿不等待。',
  },
  {
    id: 'f4',
    icon: 'ri-calendar-check-line',
    title: '每日精品更新',
    desc: '编辑团队每日精选最新好片，帮你从海量内容中快速找到心头好。',
  },
  {
    id: 'f5',
    icon: 'ri-heart-2-line',
    title: '个性化推荐',
    desc: '根据热门趋势与高分评价，智能推荐符合你口味的影视内容。',
  },
];

export const commentsData = [
  {
    id: 'c1',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20Chinese%20woman%20with%20warm%20smile%2C%20clean%20studio%20background%2C%20soft%20natural%20lighting%2C%20professional%20yet%20approachable&width=80&height=80&seq=avatar-c1&orientation=squarish',
    name: '林小雨',
    date: '2026年7月28日',
    text: '在这个站发现了好多冷门好片，推荐质量真的高。终于不用再在各大平台来回翻找，每天上来看看推荐就够用了。',
    rating: 5,
  },
  {
    id: 'c2',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20Chinese%20man%20in%20his%2030s%20with%20confident%20expression%2C%20clean%20studio%20background%2C%20soft%20natural%20lighting&width=80&height=80&seq=avatar-c2&orientation=squarish',
    name: '陈志远',
    date: '2026年7月26日',
    text: '作为一个重度电影爱好者，这里的选片品味真的很对我胃口。不是那种烂大街的推荐，每部都有独特的看点。',
    rating: 5,
  },
  {
    id: 'c3',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20Chinese%20woman%20with%20glasses%20and%20gentle%20smile%2C%20clean%20studio%20background%2C%20warm%20natural%20lighting&width=80&height=80&seq=avatar-c3&orientation=squarish',
    name: '王思琪',
    date: '2026年7月25日',
    text: '周末宅家全靠这个站选片，评论区的推荐也很有参考价值。画质确实不错，比某些收费平台还流畅。',
    rating: 4,
  },
  {
    id: 'c4',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20Chinese%20man%20in%20his%2020s%20with%20friendly%20expression%2C%20clean%20studio%20background%2C%20bright%20natural%20lighting&width=80&height=80&seq=avatar-c4&orientation=squarish',
    name: '张浩然',
    date: '2026年7月24日',
    text: '朋友推荐的站点，用了两周就离不开了。高分电影大全这个板块简直是宝藏，已经补了好多之前错过的经典。',
    rating: 5,
  },
  {
    id: 'c5',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20middle%20aged%20Chinese%20woman%20with%20warm%20elegant%20smile%2C%20clean%20studio%20background%2C%20soft%20natural%20lighting&width=80&height=80&seq=avatar-c5&orientation=squarish',
    name: '赵雅琳',
    date: '2026年7月22日',
    text: '每日更新很准时，编辑推荐语也写得很走心，不是那种复制粘贴的简介。看得出是真正热爱电影的人在运营。',
    rating: 5,
  },
];

export const cardsData = [
  {
    id: 'cd1',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20dramatic%20mountain%20landscape%20at%20golden%20hour%2C%20warm%20amber%20light%20breaking%20through%20clouds%2C%20epic%20scale%2C%20cinematic%20widescreen%20composition%2C%20rich%20warm%20tones%2C%20soft%20film%20grain%20texture&width=600&height=400&seq=card-cd1&orientation=landscape',
    title: '2026暑期档必看：十部口碑炸裂的高分电影',
    desc: '从温情治愈到悬疑烧脑，这份片单涵盖了今年最值得花时间品味的电影作品。',
    tag: '精品推荐',
  },
  {
    id: 'cd2',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20couple%20walking%20through%20rain%20soaked%20city%20street%20at%20night%2C%20reflections%20on%20wet%20pavement%2C%20neon%20lights%20softly%20blurred%2C%20intimate%20romantic%20mood%2C%20cinematic%20atmosphere&width=600&height=400&seq=card-cd2&orientation=landscape',
    title: '那些年我们错过的冷门佳作：豆瓣8.5+小众电影',
    desc: '不是所有好电影都登上过热搜，但这些被低估的作品每一部都值得被看见。',
    tag: '冷门佳片',
  },
  {
    id: 'cd3',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20science%20fiction%20scene%20with%20glowing%20nebula%20and%20distant%20stars%20through%20spaceship%20window%2C%20deep%20space%20mood%2C%20rich%20indigo%20and%20warm%20amber%20color%20contrast%2C%20cinematic%20lighting&width=600&height=400&seq=card-cd3&orientation=landscape',
    title: '科幻迷狂喜：近五年最值得看的硬核科幻电影',
    desc: '从时间旅行到人工智能，这些科幻片不止有炫目特效，更有深刻的人文思考。',
    tag: '科幻精选',
  },
  {
    id: 'cd4',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20animated%20film%20aesthetic%20with%20cherry%20blossoms%20floating%20in%20warm%20golden%20sunlight%2C%20dreamy%20atmosphere%2C%20soft%20focus%2C%20pastel%20warm%20tones%2C%20artistic%20cinematic%20composition&width=600&height=400&seq=card-cd4&orientation=landscape',
    title: '治愈系动画电影合集：温暖你整个周末的宝藏片单',
    desc: '吉卜力风格的高分动画，画面精美故事动人，适合一个人安静享受的午后时光。',
    tag: '动画佳作',
  },
  {
    id: 'cd5',
    image: 'https://readdy.ai/api/search-image?query=Intense%20action%20film%20still%20with%20dramatic%20silhouette%20against%20fiery%20orange%20sunset%20sky%2C%20dust%20particles%20floating%20in%20light%2C%20epic%20scale%2C%20cinematic%20color%20grading%2C%20powerful%20composition&width=600&height=400&seq=card-cd5&orientation=landscape',
    title: '肾上腺素飙升：2026年最值得期待的动作大片',
    desc: '从街头格斗到高空追逐，这些动作片用实拍和精良制作重新定义了爽片的标准。',
    tag: '动作巨制',
  },
];

export const topicsData = [
  { id: 't1', label: '悬疑烧脑', count: '238部', hot: true },
  { id: 't2', label: '温情治愈', count: '156部', hot: false },
  { id: 't3', label: '科幻巨制', count: '189部', hot: true },
  { id: 't4', label: '动画佳作', count: '142部', hot: false },
  { id: 't5', label: '犯罪惊悚', count: '201部', hot: true },
  { id: 't6', label: '浪漫爱情', count: '118部', hot: false },
  { id: 't7', label: '历史传记', count: '95部', hot: false },
  { id: 't8', label: '纪录片', count: '167部', hot: false },
  { id: 't9', label: '喜剧搞笑', count: '173部', hot: true },
];

export const aboutData = {
  title: '关于我们',
  description: '91免费在线视频是一个专注于精品影视推荐的在线平台，致力于为广大影迷提供高质量的电影和电视剧推荐服务。我们的编辑团队每天精心筛选来自全球的优秀影视作品，涵盖悬疑、科幻、动画、剧情、纪录片等多种类型。我们相信，每一部好电影都值得被看见，每一位观众都值得拥有更好的观影体验。平台始终坚持免费、高清、流畅的服务理念，让你随时随地享受优质影视内容。',
};

export const updatesData = [
  {
    id: 'u1',
    date: '2026.07.31',
    title: '暑期档特别策划上线：百部高分电影一网打尽',
    summary: '精心整理了近五年评分最高的百部电影，按类型分类方便快速查找，助你度过一个充实的观影夏天。',
  },
  {
    id: 'u2',
    date: '2026.07.28',
    title: '纪录片专区全新改版，新增自然与人文两大分类',
    summary: '收录 BBC、国家地理等顶级制作方的高分纪录片，画面精美内容深刻，带你探索世界的每一个角落。',
  },
  {
    id: 'u3',
    date: '2026.07.25',
    title: '本周编辑精选：五部让人看完久久不能平静的电影',
    summary: '从社会现实到人性探讨，这五部电影用不同的方式触动了我们的心弦，强烈推荐给喜欢深度观影的你。',
  },
  {
    id: 'u4',
    date: '2026.07.22',
    title: '动画电影周启动：从宫崎骏到新海诚，一次看个够',
    summary: '集结日本动画史上的经典之作，配合深度影评解析，带你重温那些感动过无数人的动画名场面。',
  },
  {
    id: 'u5',
    date: '2026.07.19',
    title: '平台播放体验升级：全站高清画质覆盖率达到98%',
    summary: '技术团队持续优化视频传输链路，即使在移动网络环境下也能享受流畅的高清观影体验。',
  },
  {
    id: 'u6',
    date: '2026.07.16',
    title: '悬疑片专题上线：从经典到新作，烧脑不停歇',
    summary: '收录希区柯克经典到近年口碑悬疑新作，每部都配有详细剧情解析和观影指南，不怕看不懂。',
  },
  {
    id: 'u7',
    date: '2026.07.12',
    title: '用户投稿功能开放：分享你的私藏片单',
    summary: '我们相信每一位影迷都有独特的品味，欢迎通过投稿联系页面分享你的观影心得和推荐片单。',
  },
];

export const appData = {
  title: '随时随地，畅享观影',
  description: '无需下载安装，手机浏览器直接访问即可享受与桌面端一致的高清观影体验。界面针对移动端深度优化，操作流畅，加载迅速，让你在地铁上、午休时、睡前都能轻松追剧看片。',
  features: ['移动端适配', '流畅播放', '即开即看', '省流模式'],
  image: 'https://readdy.ai/api/search-image?query=Smartphone%20mockup%20displaying%20elegant%20video%20streaming%20app%20interface%20with%20movie%20thumbnails%20in%20grid%20layout%2C%20warm%20cinematic%20color%20scheme%2C%20modern%20dark%20UI%20design%2C%20held%20in%20hand%20with%20blurred%20cozy%20living%20room%20background%2C%20warm%20ambient%20lighting&width=600&height=800&seq=app-mockup&orientation=portrait',
};

export const indexData = [
  {
    id: 'i1',
    title: '豆瓣 Top250 观影指南',
    count: '250部',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20classic%20film%20aesthetic%20with%20vintage%20movie%20posters%20arranged%20artistically%20on%20warm%20textured%20wall%2C%20soft%20golden%20spotlight%2C%20nostalgic%20cinema%20atmosphere%2C%20rich%20warm%20tones&width=400&height=300&seq=index-i1&orientation=landscape',
  },
  {
    id: 'i2',
    title: 'IMDb 高分必看合集',
    count: '200部',
    image: 'https://readdy.ai/api/search-image?query=Artistic%20arrangement%20of%20modern%20cinema%20elements%20with%20film%20reels%20and%20award%20statues%2C%20dramatic%20warm%20lighting%2C%20sophisticated%20gold%20and%20amber%20color%20palette%2C%20cinematic%20mood&width=400&height=300&seq=index-i2&orientation=landscape',
  },
  {
    id: 'i3',
    title: '华语电影百年经典',
    count: '180部',
    image: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20cinema%20aesthetic%20with%20red%20lanterns%20and%20classic%20film%20poster%20style%2C%20warm%20nostalgic%20atmosphere%2C%20cultural%20cinematic%20heritage%2C%20rich%20earthy%20tones&width=400&height=300&seq=index-i3&orientation=landscape',
  },
  {
    id: 'i4',
    title: '奥斯卡获奖影片全集',
    count: '320部',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20golden%20Oscar%20statuettes%20with%20classic%20film%20elements%20in%20soft%20dramatic%20lighting%2C%20prestigious%20cinema%20awards%20atmosphere%2C%20warm%20gold%20and%20cream%20tones&width=400&height=300&seq=index-i4&orientation=landscape',
  },
  {
    id: 'i5',
    title: '韩国电影必看精选',
    count: '150部',
    image: 'https://readdy.ai/api/search-image?query=Korean%20cinema%20aesthetic%20with%20dramatic%20urban%20night%20scene%2C%20neon%20accents%20and%20warm%20street%20lights%2C%20contemporary%20cinematic%20mood%2C%20rich%20contrast%20tones&width=400&height=300&seq=index-i5&orientation=landscape',
  },
  {
    id: 'i6',
    title: '日本电影美学之旅',
    count: '165部',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20cinema%20aesthetic%20with%20cherry%20blossoms%20and%20traditional%20architecture%20in%20soft%20golden%20light%2C%20minimalist%20composition%2C%20warm%20serene%20atmosphere&width=400&height=300&seq=index-i6&orientation=landscape',
  },
  {
    id: 'i7',
    title: '欧洲艺术电影珍藏',
    count: '140部',
    image: 'https://readdy.ai/api/search-image?query=European%20art%20cinema%20aesthetic%20with%20classic%20Parisian%20street%20scene%20at%20golden%20hour%2C%20vintage%20cinema%20poster%20style%2C%20romantic%20atmospheric%20mood%2C%20warm%20nostalgic%20tones&width=400&height=300&seq=index-i7&orientation=landscape',
  },
  {
    id: 'i8',
    title: '纪录片经典必看',
    count: '200部',
    image: 'https://readdy.ai/api/search-image?query=Documentary%20cinema%20aesthetic%20with%20sweeping%20landscape%20and%20camera%20equipment%20silhouette%20at%20golden%20hour%2C%20natural%20warm%20lighting%2C%20exploration%20mood%2C%20rich%20earthy%20tones&width=400&height=300&seq=index-i8&orientation=landscape',
  },
];

export const rankingData = [
  { id: 'r1', rank: 1, title: '肖申克的救赎', score: '9.7', trend: 'steady', tag: '经典' },
  { id: 'r2', rank: 2, title: '千与千寻', score: '9.4', trend: 'up', tag: '动画' },
  { id: 'r3', rank: 3, title: '盗梦空间', score: '9.3', trend: 'steady', tag: '科幻' },
  { id: 'r4', rank: 4, title: '辛德勒的名单', score: '9.5', trend: 'down', tag: '历史' },
  { id: 'r5', rank: 5, title: '星际穿越', score: '9.3', trend: 'up', tag: '科幻' },
  { id: 'r6', rank: 6, title: '泰坦尼克号', score: '9.2', trend: 'steady', tag: '爱情' },
  { id: 'r7', rank: 7, title: '寄生虫', score: '9.1', trend: 'up', tag: '剧情' },
];

export const faqData = [
  {
    id: 'faq1',
    question: '91免费在线视频需要注册吗？',
    answer: '不需要注册。本站所有内容均可免费浏览，无需登录即可查看全部精品电影推荐和电视剧介绍。我们希望让每一位影迷都能零门槛获得优质的观影参考。',
  },
  {
    id: 'faq2',
    question: '网站的视频画质如何？是否支持高清播放？',
    answer: '全站推荐内容均标注画质信息，绝大多数资源支持高清甚至超清画质。我们持续优化播放体验，确保在不同网络环境下都能获得流畅的观看效果。',
  },
  {
    id: 'faq3',
    question: '推荐的电影都是免费的吗？如何观看？',
    answer: '本站提供精品电影和电视剧的推荐与介绍，帮助你发现值得一看的好内容。具体观看渠道因影片而异，我们会尽量提供可用的在线播放信息供参考。',
  },
  {
    id: 'faq4',
    question: '如何推荐自己喜欢的电影给大家？',
    answer: '欢迎通过「投稿联系」板块与我们分享你的私藏片单和观影心得。编辑团队会认真阅读每一份投稿，优质推荐将有机会出现在精选推荐栏目中，让更多影迷发现好片。',
  },
];

export const mediaData = [
  {
    id: 'm1',
    image: 'https://readdy.ai/api/search-image?query=Mystery%20thriller%20film%20aesthetic%20with%20shadowy%20figure%20in%20dimly%20lit%20room%2C%20warm%20tungsten%20light%20casting%20long%20shadows%2C%20suspenseful%20cinematic%20mood%2C%20rich%20contrast%20and%20warm%20tones&width=640&height=360&seq=media-m1&orientation=landscape',
    title: '2026悬疑片天花板：这部烧脑神作你绝对猜不到结局',
    duration: '05:28',
    views: '12.8万',
  },
  {
    id: 'm2',
    image: 'https://readdy.ai/api/search-image?query=Bright%20colorful%20comedy%20film%20scene%20with%20festive%20celebration%20atmosphere%2C%20warm%20summer%20lighting%2C%20joyful%20vibrant%20mood%2C%20cinematic%20color%20grading%20with%20natural%20warm%20tones&width=640&height=360&seq=media-m2&orientation=landscape',
    title: '笑到肚子疼！这部喜剧片拯救你所有的不开心',
    duration: '03:45',
    views: '9.6万',
  },
  {
    id: 'm3',
    image: 'https://readdy.ai/api/search-image?query=Majestic%20wildlife%20documentary%20scene%20with%20lion%20in%20golden%20savanna%20grass%20at%20sunset%2C%20warm%20natural%20lighting%2C%20National%20Geographic%20aesthetic%2C%20rich%20earthy%20tones&width=640&height=360&seq=media-m3&orientation=landscape',
    title: '豆瓣9.8分纪录片：每一帧都可以当壁纸的自然奇观',
    duration: '08:12',
    views: '18.3万',
  },
];

export const carouselData = [
  {
    id: 'cr1',
    image: 'https://readdy.ai/api/search-image?query=Epic%20fantasy%20film%20banner%20with%20ancient%20castle%20on%20misty%20mountain%2C%20dramatic%20clouds%20and%20golden%20light%20breaking%20through%2C%20cinematic%20widescreen%20composition%2C%20rich%20warm%20tones%2C%20grand%20scale&width=1200&height=600&seq=carousel-cr1&orientation=landscape',
    title: '奇幻史诗巨制：十年磨一剑的神作系列',
    desc: '从恢弘的世界观到细腻的人物刻画，这个系列重新定义了奇幻电影的高度。',
    tag: '系列推荐',
  },
  {
    id: 'cr2',
    image: 'https://readdy.ai/api/search-image?query=Crime%20thriller%20aesthetic%20with%20detective%20silhouette%20in%20rain%20soaked%20neon%20lit%20alley%2C%20noir%20atmosphere%2C%20deep%20shadows%20and%20warm%20street%20light%2C%20cinematic%20widescreen%20composition&width=1200&height=600&seq=carousel-cr2&orientation=landscape',
    title: '犯罪片爱好者必看：近年来最震撼的悬疑佳作',
    desc: '每一部都让你屏住呼吸直到最后一秒，反转再反转的叙事让人欲罢不能。',
    tag: '悬疑精选',
  },
  {
    id: 'cr3',
    image: 'https://readdy.ai/api/search-image?query=Romantic%20drama%20banner%20with%20couple%20silhouette%20against%20vibrant%20sunset%20ocean%20horizon%2C%20warm%20golden%20and%20rose%20tones%2C%20intimate%20cinematic%20composition%2C%20soft%20atmospheric%20lighting&width=1200&height=600&seq=carousel-cr3&orientation=landscape',
    title: '七夕观影指南：十部让人相信爱情的高分电影',
    desc: '从青涩初恋到白头偕老，这些电影用最动人的方式讲述了爱情的模样。',
    tag: '浪漫推荐',
  },
  {
    id: 'cr4',
    image: 'https://readdy.ai/api/search-image?query=Sweeping%20aerial%20view%20of%20lush%20green%20forests%20and%20winding%20river%20at%20golden%20hour%2C%20natural%20lighting%2C%20epic%20scale%2C%20cinematic%20drone%20perspective%2C%20warm%20earth%20tones&width=1200&height=600&seq=carousel-cr4&orientation=landscape',
    title: '探索未知：那些改变你看世界方式的纪录片',
    desc: '从深海到太空，从远古到未来，用镜头探索人类认知的边界。',
    tag: '纪录大片',
  },
  {
    id: 'cr5',
    image: 'https://readdy.ai/api/search-image?query=Historical%20epic%20banner%20with%20ancient%20warriors%20on%20battlefield%20at%20golden%20hour%2C%20dust%20and%20atmosphere%2C%20dramatic%20cinematic%20lighting%2C%20grand%20widescreen%20composition%2C%20warm%20earthy%20tones&width=1200&height=600&seq=carousel-cr5&orientation=landscape',
    title: '历史题材电影盘点：在光影中重历波澜壮阔的时代',
    desc: '用电影的方式打开历史课本，每一部都经过精心考证，既好看又涨知识。',
    tag: '历史巨制',
  },
];

export const footerData = {
  siteName: '91免费在线视频',
  description: '精选高分电影和热门电视剧，助你告别片荒。每日更新精品推荐，全站高清画质流畅播放，必看影视一网打尽。',
  quickLinks: [
    { label: '精选推荐', href: '#cards' },
    { label: '投稿联系', href: '#contact' },
    { label: '最新动态', href: '#updates' },
    { label: '关于我们', href: '#about' },
    { label: '专题合集', href: '#index' },
    { label: '精彩视频', href: '#media' },
  ],
};